
import { NgModule } from '@angular/core';
import { SoloNumerosDirective } from './directive/solo-numeros.directive';
import { SoloLetrasDirective } from './directive/solo-letras.directive';
import { SoloNumerosPasteDirective } from './directive/solo-numeros-paste';
import { SoloNumerosEnterosDirective } from './directive/solo-numeros-enteros.directive';
import { SoloLetrasNumerosDirective } from './directive/solo-letras-numeros.directive';
import { AutocompleteLoadedDirective } from './directive/autocomplete-loaded.directive';
import { ButtonDirective } from './directive/event-tracker-button-solicitar.directive';
import { RegistrarmeDirective } from './directive/event-tracker-button-registrarme.directive';
import { ColorEstadoPipe } from '../pipe/color-estado.pipe';
import { OrdernarFechaPipe } from '../pipe/ordernar-fecha.pipe';
import { ContaintDirective } from './directive/containt.directive';
import { NumerosDecimalesDirective } from './directive/numeros-decimales.directive';
import { UnDecimalDirective } from './directive/un-decimal.directive';


@NgModule({
  declarations: [
    SoloNumerosDirective, 
    SoloLetrasNumerosDirective, 
    SoloLetrasDirective, 
    SoloNumerosPasteDirective, 
    SoloNumerosEnterosDirective,
    AutocompleteLoadedDirective,
    ColorEstadoPipe,
    OrdernarFechaPipe,
    ButtonDirective,
    RegistrarmeDirective,
    ContaintDirective,
    NumerosDecimalesDirective,
    UnDecimalDirective
    
  ],
  exports: [
    SoloNumerosDirective, 
    SoloLetrasNumerosDirective, 
    SoloLetrasDirective, 
    SoloNumerosPasteDirective, 
    SoloNumerosEnterosDirective,
    AutocompleteLoadedDirective,
    ColorEstadoPipe,
    OrdernarFechaPipe,
    ButtonDirective,
    RegistrarmeDirective,
    ContaintDirective,
    NumerosDecimalesDirective,
    UnDecimalDirective
    
  ],    
  imports: []

})
export class sharedImputDirectiveModule { }
